import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EnhancedSelectComponent } from './enhanced-select.component';

@NgModule({
  declarations: [
    EnhancedSelectComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    EnhancedSelectComponent
  ]
})
export class EnhancedSelectModule { } 